import {lazy, Suspense} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import RouterFallback from "@/modules/Shared/components/RouterFallback/RouterFallback";


const Component = lazy(async () => await import('./RegistroGraciasPage'));
export default function RegistroGracias(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate()

    return (
        <Suspense fallback={<RouterFallback/>}>
            <Component {...props} params={params} location={location} navigate={navigate}/>
        </Suspense>
    );
}
